const Chatbot = [
  {
    step: 'name',
    id: 0,
    show: true,
    toddy: true,
    strings: ['Olá me chamo Toddy. E irei lhe auxiliar a calcular o seu score jurídico. Como posso lhe chamar?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: true,
      type: 'text',
      id: 'registro_nome',
      label: 'Digite o seu nome'
    },
    steps: {
      previous: 0,
      current: 0,
      next: 1
    }
  },
  {
    step: 'intro',
    id: 1,
    show: false,
    toddy: false,
    strings: [`Muito prazer, <strong>%name%!</strong><br/>Para calcular o seu score jurídico preciso fazer mais algumas perguntas, ok!`],
    response: {
      has: false,
      show: false,
      value: ''
    },
    input: {
      has: false,
      show: false
    },
    steps: {
      previous: 0,
      current: 1,
      next: 2
    }
  },
  {
    step: 'businessPhase',
    id: 2,
    show: false,
    toddy: false,
    strings: ['Vamos começar. Em que fase está o seu negócio?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'options',
      options: [
        { label: 'Ideação', value: 'Ideação' },
        { label: 'MVP', value: 'MVP' },
        { label: 'Tração', value: 'Tração' },
        { label: 'Escala', value: 'Escala' },
        { label: 'Corporate', value: 'Corporate' }
      ]
    },
    steps: {
      previous: 1,
      current: 2,
      next: 3
    }
  },
  {
    step: 'hasConstitutedCompany',
    id: 3,
    show: false,
    toddy: false,
    strings: ['Entendido. Próxima pergunta: você já possui empresa constituída?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 2,
      current: 3,
      next: {
        true: 4,
        false: 5
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'companyType',
    id: 4,
    show: false,
    toddy: false,
    strings: ['Ok. É LTDA ou S.A?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'options',
      options: [
        { label: 'LTDA', value: 'LTDA' },
        { label: 'S.A', value: 'S.A' }
      ]
    },
    steps: {
      previous: 3,
      current: 4,
      next: 5
    }
  },
  {
    step: 'companyName',
    id: 5,
    show: false,
    toddy: false,
    strings: ['Perfeito. Agora, por favor, informe o nome da empresa.'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'text',
      id: 'registro_nome_empresa',
      label: 'Digite o nome da empresa'
    },
    steps: {
      previous: 3,
      current: 5,
      next: 6
    }
  },
  {
    step: 'email',
    id: 6,
    show: false,
    toddy: false,
    strings: ['Certo, anotado. Qual é o seu e-mail?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'email',
      id: 'registro_email',
      label: 'Digite o seu email'
    },
    steps: {
      previous: 5,
      current: 6,
      next: 7
    }
  },
  {
    step: 'jobTitle',
    id: 7,
    show: false,
    toddy: false,
    strings: ['Obrigado por fornecer. Qual é o seu cargo na empresa?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'text',
      id: 'registro_cargo',
      label: 'Digite o seu cargo'
    },
    steps: {
      previous: 6,
      current: 7,
      next: 8
    }
  },
  {
    step: 'phoneNumber',
    id: 8,
    show: false,
    toddy: false,
    strings: ['Entendi. Informe o seu telefone.'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'tel',
      id: 'registro_telefone',
      label: 'Digite o seu telefone'
    },
    steps: {
      previous: 7,
      current: 8,
      next: 9
    }
  },
  {
    step: 'headquartersState',
    id: 9,
    show: false,
    toddy: false,
    strings: ['Certo. Qual é o estado sede da empresa?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'text',
      id: 'registro_sede',
      label: 'Digite o estado sede da empresa'
    },
    steps: {
      previous: 8,
      current: 9,
      next: 10
    }
  },
  {
    step: 'sector',
    id: 10,
    show: false,
    toddy: false,
    strings: ['Entendido. E qual é o setor de atuação da empresa?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'text',
      id: 'registro_setor',
      label: 'Digite o setor de atuação'
    },
    steps: {
      previous: 9,
      current: 10,
      next: 11
    }
  },
  {
    step: 'seekingInvestment',
    id: 11,
    show: false,
    toddy: false,
    strings: ['Muito bem. Sua empresa está buscando investimento ou estará buscando nos próximos 3 meses?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 10,
      current: 11,
      next: {
        true: 12,
        false: 12
      }
    }
  },
  {
    step: 'considerMA',
    id: 12,
    show: false,
    toddy: false,
    strings: ['Obrigado por informar. Você já pensou em M&amp;A como uma alternativa de Exit para seu empreendimento?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 11,
      current: 12,
      next: {
        true: 13,
        false: 13
      }
    }
  },
  {
    step: 'consideringMA',
    id: 13,
    show: false,
    toddy: false,
    strings: ['Compreendido. Já está nesse momento?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 12,
      current: 13,
      next: {
        true: 14,
        false: 14
      }
    }
  },
  {
    step: 'hasMultiplePartners',
    id: 14,
    show: false,
    toddy: false,
    strings: ['Entendi. Você possui mais de um sócio?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 13,
      current: 14,
      next: {
        true: 15,
        false: 15
      }
    }
  },
  {
    step: 'hasOrganizedCaptable',
    id: 15,
    show: false,
    toddy: false,
    strings: ['Compreendido. Você possui um Captable organizado da sua empresa?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 14,
      current: 15,
      next: {
        true: 16,
        false: 16
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'hasShareholderAgreement',
    id: 16,
    show: false,
    toddy: false,
    strings: ['Entendido. Você possui Acordo de Sócios?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 15,
      current: 16,
      next: {
        true: 17,
        false: 17
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'promisedEquity',
    id: 17,
    show: false,
    toddy: false,
    strings: ['Perfeito. Você já prometeu participação societária "equity" para algum colaborador?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 16,
      current: 17,
      next: {
        true: 18,
        false: 18
      }
    }
  },
  {
    step: 'receivedInvestment',
    id: 18,
    show: false,
    toddy: false,
    strings: ['Certo. Você já recebeu investimento?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 17,
      current: 18,
      next: {
        true: 19,
        false: 19
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'registeredTrademark',
    id: 19,
    show: false,
    toddy: false,
    strings: ['Compreendido. Você já registrou sua marca?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 18,
      current: 19,
      next: {
        true: 20,
        false: 20
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'employeeContractType',
    id: 20,
    show: false,
    toddy: false,
    strings: ['Entendido. Os colaboradores na sua empresa são em qual formato de contratação?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'options',
      options: [
        { label: 'PJ', value: 'PJ' },
        { label: 'CLT', value: 'CLT' }
      ]
    },
    steps: {
      previous: 19,
      current: 20,
      next: 21
    }
  },
  {
    step: 'numberOfEmployees',
    id: 21,
    show: false,
    toddy: false,
    strings: ['Perfeito. Quantos colaboradores você possui?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'options',
      options: [
        { label: '0-10', value: '0-10' },
        { label: '10-50', value: '10-50' },
        { label: '50-150', value: '50-150' },
        { label: '150-1000', value: '150-1000' },
        { label: '+ de 1000', value: '+ de 1000' }
      ]
    },
    steps: {
      previous: 20,
      current: 21,
      next: 22
    }
  },
  {
    step: 'formalizeContracts',
    id: 22,
    show: false,
    toddy: false,
    strings: ['Entendido. Você formaliza seus contratos com os clientes?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 21,
      current: 22,
      next: {
        true: 23,
        false: 23
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'lgpdCompliance',
    id: 23,
    show: false,
    toddy: false,
    strings: ['Compreendido. Você já realizou alguma ação voltada à adequação LGPD?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 22,
      current: 23,
      next: {
        true: 24,
        false: 24
      }
    },
    calc: {
      true: 10,
      false: 0
    }
  },
  {
    step: 'regulatedMarket',
    id: 24,
    show: false,
    toddy: false,
    strings: ['Entendido. O mercado em que seu negócio atua é regulado?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 23,
      current: 24,
      next: {
        true: 25,
        false: 25
      }
    }
  },
  {
    step: 'litigationStatus',
    id: 25,
    show: false,
    toddy: false,
    strings: ['Compreendido. A empresa possui algum litígio em andamento ou foi alvo de ações judiciais recentes?'],
    response: {
      has: true,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'boolean'
    },
    steps: {
      previous: 24,
      current: 25,
      next: {
        true: 26,
        false: 26
      }
    },
    calc: {
      true: -10,
      false: 10
    }
  },
  {
    step: 'end',
    id: 26,
    show: false,
    toddy: false,
    strings: [`Obrigado por responder a todas as perguntas! Agora irei calcular o seu score jurídico e apresentar a sua pontuação. Só um momento, por favor.`],
    response: {
      has: false,
      show: false,
      value: ''
    },
    input: {
      has: false,
      show: false
    },
    steps: {
      previous: 25,
      current: 26,
      next: 27
    }
  },
  {
    step: 'score',
    id: 27,
    show: false,
    toddy: false,
    strings: [``],
    response: {
      has: false,
      show: false,
      value: ''
    },
    input: {
      has: false,
      show: false
    },
    steps: {
      previous: 26,
      current: 27,
      next: 28
    }
  },
  {
    step: 'greetings',
    id: 28,
    show: false,
    toddy: false,
    strings: [`Obrigado novamente por responder a todas as perguntas e tenha um ótimo dia!`],
    response: {
      has: false,
      show: false,
      value: ''
    },
    input: {
      has: true,
      show: false,
      type: 'options',
      options: [
        { label: 'Concluir', value: 'Concluir' }
      ]
    },
    steps: {
      previous: 27,
      current: 28,
      next: 28
    }
  }
]

export default Chatbot



// WEBPACK FOOTER //
// ./src/models/Chatbot.js